import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

type Props = {
  variant?: 'green' | 'red' | 'grey' | 'yellow';
  label?: string;
  blink?: boolean;
};

export default function CollectorStatusIndicator({ variant, label }: Props) {
  const color = () => {
    switch (variant) {
      case 'green':
        return '#5eba00';
      case 'red':
        return '#fa4654';
      case 'yellow':
        return '#f1c40f';
      case 'grey':
      default:
        return '#dee2e6';
    }
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faCircle}
        color={color()}
        size="1x"
        style={{ marginRight: 4, marginTop: 4 }}
      />
      {label}
    </>
  );
}
